import api from '../api'
import _ from 'underscore';
import Store from '@/store'

const answer = ({ commit }, args, delay=500) => {
  commit('SURVEY_ANSWERING', true);

  if(_.has(args, 'delay')){
    delay = parseInt(args.delay);
    delete(args.delay);
  }

  return new Promise((resolve, reject) => {
    setTimeout( function() {

      return api.answer(args)
        .then( (response) => {
          commit('SURVEY_USER_STATE', {
            completed: true,
            canComplete: false
          })

          commit('SURVEY_ANSWERING', false);

          Store.state.Auth.credits += response.data.credits
          return resolve(response.data);
        })
        .catch((error) => {
          commit('SURVEY_ANSWERING', false);

          return reject(error);
        });

      },
      delay
    );

  });

}

const getForUser = ({ commit }, args) => {
  return api.getForUser(args)
    .then(response => {
      commit('SURVEY_USER_STATE', {calendar_id: args.calendar_id, ...response.data})

      return response;
    })
    .catch(error => {
      return error;
    });
}

export default {
  answer,
  getForUser
}
